/* eslint-disable global-require */
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import {
  BRow, BCol, BModal, BLink, BFormGroup, BFormInput, BCardText, BCardTitle, BImg, BForm, BSpinner, BButton, VBTooltip,
} from 'bootstrap-vue'
import { required, forgotpasswordEmail } from '@validations'
import { togglePasswordVisibility } from '@core/mixins/ui/forms'
import { $themeConfig } from '@themeConfig'
import provider from '@/provider/provider'
import { FORGOT_PASSWORD } from '@/provider/url'
import RecaptchaInvisible from '@core/components/recaptcha/RecaptchaInvisible.vue'
import { NoSpace } from '@/libs/helpers'
import { newAxiosIns } from '@/libs/axios'
import moment from 'moment'

export default {
  directives: {
    'b-tooltip': VBTooltip,
  },
  components: {
    BRow,
    BCol,
    BLink,
    BFormGroup,
    BFormInput,
    BModal,
    BCardText,
    BCardTitle,
    BImg,
    BForm,
    BButton,
    BSpinner,
    ValidationProvider,
    ValidationObserver,
    RecaptchaInvisible,
  },
  mixins: [togglePasswordVisibility],
  data() {
    return {
      error: '',
      status: '',
      usernameEmail: '',
      emailverifikasi: '',
      showResendEmailVerification: false,
      dismissCountDown: 0,
      dismissSecs: 0,
      loading: false,
      custommessages: {
        required: 'Email harus diisi',
      },
      password: '',
      required,
      forgotpasswordEmail,

      NoSpace,
    }
  },
  setup() {
    // App Name
    const { appName, appLogoImage } = $themeConfig.app

    return {
      // App Name
      appName,
      appLogoImage,
    }
  },
  computed: {
    passwordToggleIcon() {
      return this.passwordFieldType === 'password' ? 'EyeIcon' : 'EyeOffIcon'
    },
    resendTextStyle() {
      if (this.dismissSecs > 0) {
        return {
          color: '#828282',
        }
      }
      return {
        color: '#F95031',
      }
    },
  },
  methods: {
    handleClickResend() {
      if (this.dismissSecs === 0) {
        this.sendForgotPassord()
      }
    },
    handleClickMasuk() {
      this.$router.push('login')
    },
    countDownChanged() {
      if (this.dismissSecs > 0) {
        setTimeout(() => {
          this.dismissSecs -= 1
          this.countDownChanged()
        }, 1000)
      }
    },
    handleRedirectTodataforgot() {
      this.$router.push('login')
    },
    submit() {
      this.$refs.loginForm.validate().then(success => {
        if (success) {
          this.sendForgotPassord()
        }
      })
    },
    async sendForgotPassord() {
      this.loading = true
      this.error = ''
      this.emailverifikasi = ''
      try {
        const recaptchaToken = await this.$refs.recaptcha.execute('FORGOT_PASSWORD')
        const { data: response } = await newAxiosIns.post(FORGOT_PASSWORD, {
          email: this.usernameEmail,
          recaptcha_token: recaptchaToken,
        })
        const waitSeconds = response && response.data && response.data.wait_seconds
        this.startCountdown(waitSeconds)
        this.showResendEmailVerification = true
      } catch (error) {
        this.handleErrorResponse(error)
      } finally {
        this.loading = false
      }
    },
    startCountdown(seconds) {
      this.dismissSecs = seconds || 60
      this.$nextTick(() => this.countDownChanged())
    },
    handleErrorResponse(error) {
      const res = (error && error.response && error.response.data) || {}
      const status = error && error.response && error.response.status
      const message = res.message || (res.meta && res.meta.message) || 'Terjadi kesalahan'

      if (res.data && res.data.wait_seconds) {
        this.startCountdown(res.data.wait_seconds)
        this.showResendEmailVerification = true
        return
      }
      if (status === 429 || /limit|batas/i.test(message)) {
        this.emailverifikasi = 'Batas permintaan tercapai. Silakan coba lagi dalam 24 jam.'
        return
      }
      if (message === 'Reset Password failed, invalid role id') {
        this.emailverifikasi = 'Maaf email kamu terdaftar di role lain pada Komerce. Silakan gunakan email lain.'
      } else if (/email belum terdaftar|already registered/i.test(message)) {
        this.emailverifikasi = 'Email belum terdaftar'
      } else {
        this.emailverifikasi = message
      }
    },
  },
}
